export default "/images/share.svg?50a1309b7798d80f7d2e288c9fc6364d";